import React from 'react';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';

import {
    entitlementDetailsViewLabel,
    entitlementDetailsViewOffsetContainer,
} from '../entitlement-details-view.module.styl';

import type {EntitlementsResource} from '../../typedef';

type Props = {
    resources: EntitlementsResource[],
    onResourceClick: (resourceId: string) => void,
};

export const ResourcesList = ({resources, onResourceClick}: Props) => (
    <ul>
        {resources.map(({externalId, name: resourceName}, i) => (
            <li
                key={i}
                className={`${entitlementDetailsViewOffsetContainer} ${entitlementDetailsViewLabel}`}
                onClick={() => onResourceClick(externalId)}>
                <EllipsisTextHint title={resourceName}>
                    <a>{resourceName}</a>
                </EllipsisTextHint>
            </li>
        ))}
    </ul>
);
